export default "__VITE_ASSET__CvfL_6HG__"